export default "/images/aacd5fcc54047a783e9d7753bfb2625e.avif";